<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" id="vol-1-dedication">
<div class="text" id="vol-1-dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">My mother, Jean Woodson</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">My grandmother, Mildred E. Williams</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">My brother, Eric Harold Spears</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">My nieces, LaKecia Janise Woodson,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Tanisha Donique Woodson</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Emmanuel D. McDavid</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Rising stars who left us much too soon</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">To Leslie Esdaile Banks (L.A. Banks),</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">one of the best storytellers the planet had to offer.</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">To Anthony “Green Eyes” Johnson,</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">the real life “Dallas” who taught me</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">what unconditional love was all about</p>
</div>
</div>
<hr class="implicit-break"/>
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">to Derek V. Fields</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">and the C.V.S. graduating class of 1984</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001dedication.vue?a6d7807c